var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg001(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.13954 0.974767L6.13954 5.75238L4.09302 6.87653L2.9512e-07 4.62823L6.13954 0.974767Z",
    fill: "#080808"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5714 4.62721L12.5714 11.3721L8.18604 9.1238L8.18604 6.8755L12.5714 4.62721Z",
    fill: "#080808"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.09302 9.12348L6.13954 10.2476L6.13954 15.0252L4.79567e-07 11.3717L4.09302 9.12348Z",
    fill: "#080808"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg001);
export default __webpack_public_path__ + "static/media/001.fd714e43c9dfedc6597b3b4f1ce62eba.svg";
export { ForwardRef as ReactComponent };